import { apiGet, apiPost } from './restAPI';
import axios from 'axios';

const API_NAME = 'CoreAPI2';
const CRONOFY_API_BASE = 'https://api.cronofy.com';

export async function getCronofyEvents(from, to, tzid = 'Etc/UTC') {
  try {
    const params = new URLSearchParams();
    if (from) params.append('from', from);
    if (to) params.append('to', to);
    if (tzid) params.append('tzid', tzid);
    
    const queryString = params.toString() ? `?${params.toString()}` : '';
    return await apiGet(API_NAME, `/x2/cronofy/events${queryString}`, {});
  } catch (error) {
    console.error('Error fetching Cronofy events:', error);
    throw error;
  }
}

export async function getUserInfo() {
  try {
    return await apiGet(API_NAME, '/x2/cronofy/userinfo', {});
  } catch (error) {
    console.error('Error getting user info:', error);
    throw error;
  }
}

export async function getElementToken(permissions = [], userIds = []) {
  try {
    const isDev = process.env.NODE_ENV === 'development';
    return await apiPost(API_NAME, '/x2/cronofy/element-token', {
      body: { 
        permissions, 
        userIds,
        dev: isDev
      }
    });
  } catch (error) {
    console.error('Error getting element token:', error);
    throw error;
  }
}
